import {
    BIG_RESERVATION_M2,
    BIG_RESERVATION_UNIT, SHOW_LOT_NUMBER as SHOW_LOT_NUMBER_TR,
    STOCK_RESERVATION_TIME,
    STOCK_RESERVATION_TIME_CHECKOUT,
    ECHO_MAX_WEIGHT_LBS,
    ECHO_MAX_PALLETS,
} from 'i18n/translations/TR';
import i18next from 'i18next';

export enum SettingNameValue {
    BIG_RESERVE_UNIT= 'BIG_RESERVE_UNIT',
    BIG_RESERVE_M2= 'BIG_RESERVE_M2',
    STOCK_RESERVE_TIME= 'STOCK_RESERVE_TIME',
    STOCK_RESERVE_TIME_CHECKOUT= 'STOCK_RESERVE_TIME_CHECKOUT',
    CUT_OFF_HOUR= 'CUT_OFF_HOUR',
    CARRIER_PICKUP_BEFORE_CUT_OFF_HOUR= 'CARRIER_PICKUP_BEFORE_CUT_OFF_HOUR',
    CARRIER_PICKUP_AFTER_CUT_OFF_HOUR= 'CARRIER_PICKUP_AFTER_CUT_OFF_HOUR',
    CARRIER_SHIPPING_PROCESSING_HOURS_TO_ADD= 'CARRIER_SHIPPING_PROCESSING_HOURS_TO_ADD',
    CARRIER_INSURANCE= 'CARRIER_INSURANCE',
    PICK_HANDLE_PRICE= 'PICK_HANDLE_PRICE',
    PICK_HANDLE_ACCOUNT= 'PICK_HANDLE_ACCOUNT',
    IN_MAINTENANCE= 'IN_MAINTENANCE',
    SHOW_LOT_NUMBER= 'SHOW_LOT_NUMBER',
    SHIPMENT_ECHO_MAX_WEIGHT_LBS= 'SHIPMENT_ECHO_MAX_WEIGHT_LBS',
    SHIPMENT_ECHO_MAX_PALLETS= 'SHIPMENT_ECHO_MAX_PALLETS',
    SAMPLE_ACCOUNT= 'SAMPLE_ACCOUNT',
    SAMPLE_FULL_PRICE_QUANTITY_LIMIT= 'SAMPLE_FULL_PRICE_QUANTITY_LIMIT',
    SAMPLE_OVER_LIMIT_DISCOUNT_PERCENT= 'SAMPLE_OVER_LIMIT_DISCOUNT_PERCENT',
}

export class SettingName {

    constructor(private _value: SettingNameValue) {}

    get value(): SettingNameValue {
        return this._value;
    }

    get translate(): string {
        switch (this._value) {
            case SettingNameValue.BIG_RESERVE_UNIT:
                return i18next.t(BIG_RESERVATION_UNIT);
            case SettingNameValue.BIG_RESERVE_M2:
                return i18next.t(BIG_RESERVATION_M2);
            case SettingNameValue.STOCK_RESERVE_TIME:
                return i18next.t(STOCK_RESERVATION_TIME);
            case SettingNameValue.STOCK_RESERVE_TIME_CHECKOUT:
                return i18next.t(STOCK_RESERVATION_TIME_CHECKOUT);
            case SettingNameValue.SHOW_LOT_NUMBER:
                return i18next.t(SHOW_LOT_NUMBER_TR);
            case SettingNameValue.SHIPMENT_ECHO_MAX_WEIGHT_LBS:
                return i18next.t(ECHO_MAX_WEIGHT_LBS);
            case SettingNameValue.SHIPMENT_ECHO_MAX_PALLETS:
                return i18next.t(ECHO_MAX_PALLETS);
            default:
                return '';
        }
    }

}
